import React from 'react';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import DeviationTorpedo from '../../../Torpedo/DeviationTorpedo';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
const container = {
    width: 450,
    maxRows: 3
};
const defaultSize = {
    desktop: {
        width: 450,
        height: 0
    },
    mobile: {
        width: 375,
        height: 0
    }
};
const ExhibitionistGrid = ({ moduleId })=>{
    const { moduleData } = useModuleData(moduleId);
    const { deviations } = moduleData;
    return /*#__PURE__*/ React.createElement(DeviationTorpedo, {
        items: deviations,
        container: container,
        cookieType: MeasuredCookieType.USER_PROFILE_FEATURED,
        cookieDim: 'width',
        defaultSize: defaultSize,
        hideIncompleteRows: true,
        enableScrollVisibilityOptimisation: true
    });
};
ExhibitionistGrid.displayName = 'ExhibitionistGrid';
export default ExhibitionistGrid;

//# sourceMappingURL=ExhibitionistGrid.js.map